import { jwtDecode } from 'jwt-decode';
import React, { Component } from "react";
import { Form, Modal } from 'react-bootstrap';
import '../../assets/css/apps/apps.css';
import '../../assets/css/auth.css';
import logoBeta from "../../assets/img/logo-beta.png";
import slideWorkflow from "../../assets/img/slide-workflow.png";
import slideAgents from "../../assets/img/slide-agents.png";
import slideGateway from "../../assets/img/slide-gateway.png";
import slidePolicy from "../../assets/img/slide-policy.png";
import LoginChatView from "../../pages/auth/LoginChatView";
import { showNotificationGlobal } from "../../components/common/NotificationProvider";
import withNavigate from '../../components/withNavigate';
import LoginService from "../../services/api/login";
import UserService from "../../services/api/user";
import { getYear, validateForm } from "../../settings/shared/commonMethods";
import { messages } from "../../settings/shared/CommonMessages";
import { ACCESS_TOKEN, API_RESPONSE, APP_VERSION, defaultTenant, GOOGLE_AUTH_URL, MICROSOFT_AUTH_URL, SIGNIN_AUTH_TOKEN, validEmailRegex } from '../../settings/shared/constants';
import { captureDesktopOAuthFromSearch, completeDesktopOAuth, isDesktopOAuth, preserveDesktopOAuthAcrossClear } from '../../settings/shared/desktopOAuth';
import google from '../../assets/img/cloud/google.svg';
import microsoft from '../../assets/img/icons/svg/microsoft.svg';
import { getRecaptchaSiteKey, getRecaptchaToken, loadRecaptcha } from '../../utils/recaptcha';

const HERO_TITLE = "The AI Engineering Platform for Autonomous AI";
const HERO_DESCRIPTION = "Build, run, govern, and scale AI agents and applications with security, control, and observability built-in";

const SLIDES = [
    { image: slideWorkflow, label: "Agent Workflow Builder", chips: ["Drag & drop", "Human-in-the-loop", "Deploy in minutes"] },
    { image: slideAgents,   label: "Agents in Action",       chips: ["Real-time execution", "Detailed traces", "Cost tracking"] },
    { image: slideGateway,  label: "LLM Gateway",            chips: ["Multi-model", "Unified API", "Guardrails"] },
    { image: slidePolicy,   label: "Policy Engine",          chips: ["Policy-as-code", "Human approval", "Audit & compliance"] },
];

// How long each slide stays in front before the carousel rotates (ms)
const SLIDE_INTERVAL = 5000;


    class Login extends Component {
        constructor(props) {
            super(props);

            const desktopOAuth = captureDesktopOAuthFromSearch(window.location.search);
            const isDesktopLogin = Boolean(desktopOAuth) || isDesktopOAuth();

            this.state = {
                height: window.innerHeight,
                showLoginForm:
                    isDesktopLogin ||
                    props.location?.state?.showLoginForm ||
                    false,
                loginMethod: props.location?.state?.loginMethod || "auth0",
                errors: {
                    email: '',
                    password: '',
                    privacyAccepted: ''
                },
                turn: 0,
                paused: false,
                authStep: "email",
                checkingEmail: false,
                confirmedEmail: "",
                password: "",
                showPassword: false,
                submittingPassword: false,
                privacyAccepted: false,
                showPrivacyPolicy: false,
                isDesktopLogin,
            };
        
            this.slides = SLIDES;
            this.stageRef = React.createRef();
        }

    componentDidMount() {
        this.autoTimer = setInterval(() => {
            // only rotate while the sign-in view (with the showcase) is visible
            if (this.state.showLoginForm && !this.state.paused) this.goToNext();
        }, SLIDE_INTERVAL);
        loadRecaptcha().catch(() => {});
    }

    componentWillUnmount() {
        clearInterval(this.autoTimer);
    }

    scrollFieldIntoComfortableView = (el) => {
        if (!el || typeof el.scrollIntoView !== 'function') return;
        requestAnimationFrame(() => {
            el.scrollIntoView({ block: 'center', behavior: 'smooth', inline: 'nearest' });
        });
    };

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;

        switch (name) {
            case 'email':
                if (!value) {
                    errors.email = 'Email is required!';
                } else if (!validEmailRegex.test(value)) {
                    errors.email = 'Email is not valid!';
                } else {
                    errors.email = '';
                }
                break;
            case 'password':
                errors.password = value === "" ? 'Please enter password' : '';
                break;
            default:
                break;
        }
        this.setState({ errors, [name]: value });
    }

    handlePrivacyAcceptedChange = (event) => {
        const { checked } = event.target;

        this.setState((prevState) => ({
            privacyAccepted: checked,
            errors: {
                ...prevState.errors,
                privacyAccepted: checked ? '' : prevState.errors.privacyAccepted
            }
        }));
    }

    handleContinue = async (event) => {
        event.preventDefault();

        const { email, errors, privacyAccepted } = this.state;

        if (!privacyAccepted) {
            this.setState({
                errors: {
                    ...errors,
                    privacyAccepted: 'Please agree to the Privacy Policy to continue.'
                }
            });
            return;
        }

        if (!email) {
            return showNotificationGlobal("Please enter Email ID", "error");
        }

        if (!validateForm(errors)) {
            console.error("Invalid form");
            return;
        }

        const emailToCheck = email.toLowerCase();

        let recaptchaToken = "";
        try {
            recaptchaToken = await getRecaptchaToken("LOGIN");
        } catch (error) {
            return showNotificationGlobal(error?.message || "Couldn't verify this sign-in. Please try again.", "error");
        }

        try {
            this.setState({ checkingEmail: true });

            const response = await LoginService.loginVerify(emailToCheck, recaptchaToken);
             if (response?.status === API_RESPONSE.SUCCESS) {
                if (response?.token) {
                    sessionStorage.setItem(SIGNIN_AUTH_TOKEN, response.token);
                }
                this.setState({
                    authStep: "social",
                    confirmedEmail: emailToCheck,
                    checkingEmail: false
                });
                return;
            }

            this.setState({ checkingEmail: false });
            return showNotificationGlobal(response?.errorMessage || "Email is not registered", "info");
        } catch (error) {
            this.setState({ checkingEmail: false });
            showNotificationGlobal(
                error?.response?.data?.errorMessage || "Unexpected error occurred",
                "error"
            );
        }
    }

    // Step 2: Navigate to OTP screen with typed email
    goToVerifyOtp = async () => {
        const email = (this.state.confirmedEmail || this.state.email || "").toLowerCase();
        if (!email) {
            return showNotificationGlobal("Please enter Email ID", "error");
        }
        else{
            try {
                const recaptchaToken = await getRecaptchaToken("LOGIN_OTP");
                const response = await LoginService.auth(email, recaptchaToken);      
                if (response.status === API_RESPONSE.SUCCESS) {
                  sessionStorage.setItem(SIGNIN_AUTH_TOKEN, response.token);
                  showNotificationGlobal(messages.otpSentMessage, "success");    
                  setTimeout(() => {
                     this.props.navigate("/auth/verify-otp", { state: { email: email } });        
                  }, 1000);
                }
      
                if (response.status === API_RESPONSE.FAILURE) {
                  return showNotificationGlobal(response.errorMessage, "error");
                }
      
              } catch (error) {
                showNotificationGlobal(error?.response?.data?.errorMessage || "You can receive an OTP only if you are an authenticated user.", "error");
              }
        }
        // return this.props.navigate("/auth/verify-otp", { state: { email } });
    }

    // Clear form data after form submit
    clearformData() {
        this.setState({
            checked: false,
            email: "",
            password: "",
            privacyAccepted: false,
            errors: {
                email: '',
                password: '',
                privacyAccepted: ''
            },
        })
    }

    switchToAuth0 = () => {
        this.setState({
            loginMethod: "auth0",
            authStep: "email",
            confirmedEmail: "",
            checkingEmail: false
        });
    }

    switchToPassword = () => {
        this.setState({
            loginMethod: "password",
            authStep: "email",
            confirmedEmail: "",
            checkingEmail: false
        });
    }

    getLoginCopy = () => {
        const { isDesktopLogin, authStep, loginMethod } = this.state;
        if (loginMethod === "password") {
            return {
                title: isDesktopLogin ? "Sign in to Desktop" : "Sign in",
                subtitle: isDesktopLogin
                    ? "Enter your SuperAgentX email and password to continue in the desktop app."
                    : "Sign in with your email and password"
            };
        }
        return {
            title: isDesktopLogin ? "Sign in to Desktop" : "Sign in",
            subtitle: isDesktopLogin
                ? (authStep === "email"
                    ? "Enter your SuperAgentX email to continue in the desktop app."
                    : "Choose how you want to sign in, then return to SuperAgentX Desktop.")
                : (authStep === "email"
                    ? "Enter email registered on SuperAgentX"
                    : "Choose how you want to sign in.")
        };
    }

    getUserDetails = () => {
        UserService.getuserdetails()
            .then((res) => {
                localStorage.setItem("profile", JSON.stringify(res));
                localStorage.setItem("accountId", res.accountId);
                localStorage.setItem("tenant", res.tenant);
                showNotificationGlobal("Logged in successfully.", "success");
                setTimeout(() => {
                    this.props.navigate("/apps");
                }, 1000);
            }).catch(() => {
                this.setState({ submittingPassword: false });
            })
    }

    finishPasswordLogin = async ({ email, authToken, tenants }) => {
        sessionStorage.setItem(SIGNIN_AUTH_TOKEN, authToken);
        try {
            localStorage.setItem("tenantList", JSON.stringify(tenants));
            localStorage.setItem("loginEmail", email);
        } catch (e) {}

        if (tenants.length > 1) {
            this.setState({ submittingPassword: false });
            return this.props.navigate("/auth/tenants", {
                state: { tenantList: tenants, email }
            });
        }

        const tenant = tenants[0];
        localStorage.setItem("accountLogo", tenant?.accountLogo);
        localStorage.setItem("accountName", tenant?.accountName);

        const tenantData = {
            email: email.toLowerCase(),
            authToken: sessionStorage.getItem(SIGNIN_AUTH_TOKEN),
            accountId: tenant?.accountID,
        };

        const validateResponse = await LoginService.validateAuth(tenantData);

        if (validateResponse.status === API_RESPONSE.SUCCESS) {
            const decoded = jwtDecode(validateResponse.token);
            localStorage.setItem(ACCESS_TOKEN, validateResponse.token);
            localStorage.setItem("Uid", decoded?.id);
            if (decoded?.roles?.length > 0) {
                localStorage.setItem("role", decoded.roles[0]);
            }

            if (isDesktopOAuth()) {
                this.setState({ submittingPassword: false });
                showNotificationGlobal("Opening SuperAgentX Desktop…", "success");
                try {
                    await completeDesktopOAuth({
                        accessToken: validateResponse.token,
                        authorizeFn: (payload) => LoginService.authorizeDesktop(payload),
                    });
                } catch (err) {
                    showNotificationGlobal(
                        err?.message || "Could not return to SuperAgentX Desktop. Try again.",
                        "error"
                    );
                }
                return;
            }

            const restoreDesktop = preserveDesktopOAuthAcrossClear();
            sessionStorage.clear();
            restoreDesktop();
            return this.getUserDetails();
        }

        if (validateResponse.token) {
            const decoded = jwtDecode(validateResponse.token);
            localStorage.setItem("Uid", decoded?.id);
            if (decoded?.roles?.length > 0) {
                localStorage.setItem("role", decoded.roles[0]);
            }
            localStorage.setItem("Login_State", false);
            localStorage.setItem(ACCESS_TOKEN, validateResponse.token);
            sessionStorage.clear();
            this.setState({ submittingPassword: false });
            showNotificationGlobal(validateResponse.errorMessage, "error");
            return this.props.navigate("/auth/update-password");
        }

        this.setState({ submittingPassword: false });
        return showNotificationGlobal(validateResponse.errorMessage || "Authentication failed", "error");
    }

    handlePasswordSubmit = async (event) => {
        event.preventDefault();

        const { email, password, errors, privacyAccepted } = this.state;

        if (!privacyAccepted) {
            this.setState({
                errors: {
                    ...errors,
                    privacyAccepted: 'Please agree to the Privacy Policy to continue.'
                }
            });
            return;
        }

        if (!email && !password) {
            return showNotificationGlobal("Please enter all required fields", "error");
        }
        if (!email) {
            return showNotificationGlobal("Please enter Email ID", "error");
        }
        if (!password) {
            return showNotificationGlobal("Please enter password", "error");
        }
        if (!validateForm(errors)) {
            return;
        }

        const emailToUse = email.toLowerCase();
        let recaptchaToken = "";
        try {
            recaptchaToken = await getRecaptchaToken("LOGIN_PASSWORD");
        } catch (error) {
            return showNotificationGlobal(error?.message || "Couldn't verify this sign-in. Please try again.", "error");
        }
        this.setState({ submittingPassword: true });

        try {
            const response = await LoginService.loginWithPassword({
                email: emailToUse,
                password,
                ...(recaptchaToken ? { recaptchaToken } : {}),
            });

            if (response.status === API_RESPONSE.SUCCESS) {
                const tenants = response?.accountsDTOS;
                if (!tenants || tenants.length === 0) {
                    this.setState({ submittingPassword: false });
                    return showNotificationGlobal(response.errorMessage || "No Account found", "error");
                }
                return this.finishPasswordLogin({
                    email: emailToUse,
                    authToken: response.authToken,
                    tenants,
                });
            }

            if (response.status === API_RESPONSE.FAILURE && response.token) {
                const decoded = jwtDecode(response.token);
                localStorage.setItem("Uid", decoded.id);
                if (decoded?.roles?.length > 0) {
                    localStorage.setItem("role", decoded.roles[0]);
                }
                localStorage.setItem("Login_State", false);
                localStorage.setItem(ACCESS_TOKEN, response.token);
                sessionStorage.clear();
                this.setState({ submittingPassword: false });
                showNotificationGlobal(response.errorMessage, "error");
                return this.props.navigate("/auth/update-password");
            }

            this.setState({ submittingPassword: false });
            return showNotificationGlobal(response?.errorMessage || "Invalid email or password", "error");
        } catch (error) {
            this.setState({ submittingPassword: false });
            showNotificationGlobal(
                error?.response?.data?.errorMessage || "Unexpected error occurred",
                "error"
            );
        }
    }

    renderPrivacyAgreement = (disabled) => {
        const { errors, privacyAccepted } = this.state;
        return (
            <>
                <div className="login-privacy-agreement">
                    <input
                        id="privacyAccepted"
                        type="checkbox"
                        className={`login-privacy-checkbox ${errors.privacyAccepted ? 'is-invalid' : ''}`}
                        checked={privacyAccepted}
                        onChange={this.handlePrivacyAcceptedChange}
                        disabled={disabled}
                    />
                    <label htmlFor="privacyAccepted" className="login-privacy-label">
                        I agree to terms mentioned in{' '}
                        <button
                            type="button"
                            className="login-privacy-link"
                            onClick={() => this.setState({ showPrivacyPolicy: true })}
                        >
                            Privacy Policy.
                        </button>
                        <span className="login-privacy-required"> *</span>
                    </label>
                </div>
                {errors.privacyAccepted.length > 0 && (
                    <div className="invalid-feedback d-block mt-1 mb-3">
                        {errors.privacyAccepted}
                    </div>
                )}
            </>
        );
    }

    handleChatSubmit = () => {
        // When send button is clicked in chat, show login form
        this.setState({ showLoginForm: true });
    }

    handleGoogleLogin = (e) => {
        e.preventDefault();
        sessionStorage.setItem("oauthProvider", "google");
        window.location.href = GOOGLE_AUTH_URL;
    }

    handleMicrosoftLogin = (e) => {
        // TODO: Implement Microsoft OAuth login
        e.preventDefault();
        sessionStorage.setItem("oauthProvider", "microsoft");
        window.location.href = MICROSOFT_AUTH_URL
    }

    // ---- Showcase (right panel): rotating 3D carousel ----
    // `turn` keeps counting up or down so the ring always spins the short way round
    getActive = () => {
        const n = this.slides.length;
        return ((this.state.turn % n) + n) % n;
    };

    goToSlide = (index) => this.setState((s) => {
        const n = this.slides.length;
        const active = ((s.turn % n) + n) % n;
        let delta = (((index - active) % n) + n) % n;
        if (delta > n / 2) delta -= n;
        return delta ? { turn: s.turn + delta } : null;
    });

    goToPrevious = () => this.setState((s) => ({ turn: s.turn - 1 }));
    goToNext = () => this.setState((s) => ({ turn: s.turn + 1 }));

    handleDragStart = (e) => {
        this.dragStart = e.clientX;
        this.dragged = false;
    };

    handleDragEnd = (e) => {
        if (this.dragStart == null) return;
        const dx = e.clientX - this.dragStart;
        this.dragStart = null;
        if (Math.abs(dx) > 50) {
            this.dragged = true;
            dx < 0 ? this.goToNext() : this.goToPrevious();
        }
    };

    // Mouse-follow tilt: writes CSS variables directly, so there is no re-render on mouse move
    handleStageMove = (e) => {
        const el = this.stageRef.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width - 0.5;   // -0.5 .. 0.5
        const py = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ry', `${px * 8}deg`);
        el.style.setProperty('--rx', `${-py * 6}deg`);
    };

    handleStageLeave = () => {
        const el = this.stageRef.current;
        if (!el) return;
        el.style.setProperty('--ry', '0deg');
        el.style.setProperty('--rx', '0deg');
    };

    handleCardClick = (i) => {
        if (this.dragged) { this.dragged = false; return; }
        this.goToSlide(i);
    };

    renderShowcase = () => {
        const n = this.slides.length;
        const active = this.getActive();

        return (
            <div className="sx-content">
                <div className="sx-copy">
                    <h1 className="sx-title">
                        {HERO_TITLE.split(' ').map((w, i) => (
                            <span className="sx-word" key={i}>
                                <span className={i >= 5 ? 'sx-accent' : ''} style={{ '--i': i }}>{w}</span>
                            </span>
                        ))}
                    </h1>
                    <p className="sx-desc">{HERO_DESCRIPTION}</p>
                </div>

                <div
                    className="cv-wrap"
                    onMouseEnter={() => this.setState({ paused: true })}
                    onMouseLeave={() => { this.setState({ paused: false }); this.handleStageLeave(); }}
                >
                    <div
                        className="cv-stage"
                        ref={this.stageRef}
                        onMouseMove={this.handleStageMove}
                        onPointerDown={this.handleDragStart}
                        onPointerUp={this.handleDragEnd}
                        onPointerCancel={() => { this.dragStart = null; }}
                    >
                        {this.slides.map((s, i) => {
                            let off = (((i - active) % n) + n) % n;
                            if (off > n / 2) off -= n;
                            const hidden = Math.abs(off) > 1;
                            return (
                                <button
                                    type="button"
                                    key={i}
                                    className={`cv-card ${off === 0 ? 'is-front' : ''} ${hidden ? 'is-back' : ''}`}
                                    style={{ '--o': off }}
                                    onClick={() => this.handleCardClick(i)}
                                    aria-label={s.label}
                                    aria-current={off === 0}
                                    tabIndex={hidden ? -1 : 0}
                                >
                                    <span className="cv-bar"><i /><i /><i /></span>
                                    <img src={s.image} alt="" className="cv-img" draggable={false} />
                                </button>
                            );
                        })}

                        <button className="sx-arrow cv-arrow cv-arrow--prev" onClick={this.goToPrevious} aria-label="Previous slide">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </button>
                        <button className="sx-arrow cv-arrow cv-arrow--next" onClick={this.goToNext} aria-label="Next slide">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </button>
                    </div>
                </div>
            </div>
        );
    }


    render() {
        const { errors, showLoginForm, authStep, checkingEmail, confirmedEmail, showPrivacyPolicy, loginMethod, submittingPassword } = this.state;
        const loginCopy = this.getLoginCopy();
        
        // If login form is not shown, display the LandingChatView
        if (!showLoginForm) {
            return (
                <div className="auth-container">
                    {/* Top Header */}
                    <div className="auth-header">
                        <div className="header-left">
                            <div className="header-logo" style={{ position: 'relative' }}>
                                <img src={logoBeta} width={250} alt="logo" />
                            </div>
                        </div>
                        <div className="header-right">
                            <nav className="header-nav">
                                <a href="#docs" className="nav-link">Docs</a>
                                <a href="#support" className="nav-link">Support</a>
                            </nav>
                            <div className="header-actions">
                                <button className="btn btn-outline-primary btn-sm" onClick={() => this.setState({ showLoginForm: true })}>
                                    Sign In
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Show LandingChatView */}
                    <LoginChatView onSendClick={this.handleChatSubmit} />
                </div>
            );
        }

        // Show login form when showLoginForm is true
        return (
            <div className="auth-container auth-container--signin">
               
                {/* Main Content Area */}
                <div className="auth-main-content">
                    {/* Left Side - Login Form (card on soft panel) */}
                    <div className="login-form">
                        <div className="login-form-content login-signin-card">
                        {/* Logo */}
                        <div className="login-logo-top">
                            <img src={logoBeta} alt="SuperAgentX Logo" className="login-logo-img" />
                        </div>
                        
                        <div className="login-header">
                            <div className="login-title">
                                <h3 className="login-signin-card__heading font-bold mb-2">
                                    {loginCopy.title}
                                </h3>
                                <p className="login-signin-card__subtitle font-regular font13 txt-grey-50 mb-4">
                                    {loginCopy.subtitle}
                                </p>
                            </div>
                        </div>

                        {loginMethod === "password" ? (
                            <Form onSubmit={this.handlePasswordSubmit} noValidate className="login-form-fields">
                                <div className="form-group mb-3">
                                    <label className="form-label font-regular font13 mb-2">Email Address</label>
                                    <input
                                        type="email"
                                        className="form-control font-regular login-signin-card__input"
                                        placeholder="name@company.com"
                                        name="email"
                                        value={this.state.email || ""}
                                        autoComplete="email"
                                        onChange={this.handleChange}
                                        onFocus={(e) => this.scrollFieldIntoComfortableView(e.target)}
                                        noValidate
                                        disabled={submittingPassword}
                                    />
                                    {errors.email.length > 0 && (
                                        <div className="invalid-feedback d-block mt-1">
                                            {errors.email}
                                        </div>
                                    )}
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label font-regular font13 mb-2">Password</label>
                                    <div className="login-password-wrap">
                                        <input
                                            type={this.state.showPassword ? "text" : "password"}
                                            className="form-control font-regular login-signin-card__input"
                                            placeholder="Enter your password"
                                            name="password"
                                            value={this.state.password || ""}
                                            autoComplete="current-password"
                                            onChange={this.handleChange}
                                            onFocus={(e) => this.scrollFieldIntoComfortableView(e.target)}
                                            noValidate
                                            disabled={submittingPassword}
                                        />
                                        <button
                                            type="button"
                                            className="login-password-toggle"
                                            aria-label={this.state.showPassword ? "Hide password" : "Show password"}
                                            onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                        >
                                            <i className={`fas ${this.state.showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                                        </button>
                                    </div>
                                    {errors.password.length > 0 && (
                                        <div className="invalid-feedback d-block mt-1">
                                            {errors.password}
                                        </div>
                                    )}
                                </div>

                                {this.renderPrivacyAgreement(submittingPassword)}

                                <div className="mt-1">
                                    <button
                                        className="btn btn-primary font-semi-bold w-100 continue-btn mt-2"
                                        type="submit"
                                        style={{ padding: '10px 16px' }}
                                        disabled={submittingPassword}
                                    >
                                        {submittingPassword ? "Signing in..." : "Sign In"}
                                    </button>
                                </div>

                                <div className="social-login-divider mt-3 mb-3">
                                    <div className="divider-line"></div>
                                    <span className="divider-text">or</span>
                                    <div className="divider-line"></div>
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-social w-100"
                                    onClick={this.switchToAuth0}
                                    disabled={submittingPassword}
                                >
                                    Sign in with OTP
                                </button>
                            </Form>
                        ) : (
                        <>
                        <div className={`login-stepper ${authStep === "social" ? "social-active" : ""}`}>
                            {/* Step 1: Email verification */}
                            <div className="login-step login-step-email">
                                <Form onSubmit={this.handleContinue} noValidate className="login-form-fields">
                                    <div className="form-group mb-3">
                                        <label className="form-label font-regular font13 mb-2">Email Address</label>
                                        <input
                                            type="email"
                                            className="form-control font-regular login-signin-card__input"
                                            placeholder="name@company.com"
                                            name="email"
                                            value={this.state.email || ""}
                                            autoComplete="email"
                                            onChange={this.handleChange}
                                            onFocus={(e) => this.scrollFieldIntoComfortableView(e.target)}
                                            noValidate
                                            disabled={checkingEmail}
                                        />
                                        {errors.email.length > 0 && (
                                            <div className="invalid-feedback d-block mt-1">
                                                {errors.email}
                                            </div>
                                        )}
                                    </div>

                                    {this.renderPrivacyAgreement(checkingEmail)}

                                    <div className="mt-1">
                                        <button
                                            className="btn btn-primary font-semi-bold w-100 continue-btn mt-2"
                                            type="submit"
                                            style={{ padding: '10px 16px' }}
                                            disabled={checkingEmail}
                                        >
                                            {checkingEmail ? "Checking..." : "Continue"}
                                            <i className="fas fa-arrow-right continue-arrow ms-3"></i>
                                        </button>
                                    </div>

                                    <div className="social-login-divider mt-3 mb-3">
                                        <div className="divider-line"></div>
                                        <span className="divider-text">or continue with</span>
                                        <div className="divider-line"></div>
                                    </div>

                                    <div className="social-login-buttons">
                                        <button
                                            type="button"
                                            className="btn btn-social btn-google"
                                            onClick={(e) => this.handleGoogleLogin(e)}
                                            disabled={checkingEmail}
                                        >
                                            <img src={google} alt="Google" width="20" height="20" style={{ marginRight: '8px' }} />
                                            Google
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-social btn-microsoft"
                                            onClick={(e) => this.handleMicrosoftLogin(e)}
                                            disabled={checkingEmail}
                                        >
                                            <img src={microsoft} alt="Microsoft" width="20" height="20" style={{ marginRight: '8px' }} />
                                            Microsoft
                                        </button>
                                    </div>
                                </Form>
                            </div>

                            <div className="login-step login-step-social">
                                <div className="login-confirmed-email">
                                <i className="fas fa-envelope login-confirmed-email-label"></i>
                                    <span className="login-confirmed-email-value">{confirmedEmail || this.state.email || ""}</span>
                                    <button
                                        type="button"
                                        className="btn btn-link-otp"
                                        onClick={() => this.setState({ authStep: "email", confirmedEmail: "" })}
                                    >
                                        <i className="fas fa-edit me-1"></i>
                                    </button>
                                </div>

                                <div className="login-verification-link mt-3">
                                    <p className="font-regular font13 mb-3 text-center">
                                        <span style={{ color: '#64748b' }}>Unable to login? </span>
                                        <b className="txt-blue-500 font-bold" style={{ cursor: 'pointer' }} onClick={this.goToVerifyOtp}>Get Verification Code</b>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="login-method-switch">
                            <p className="font-regular font13 mb-0 text-center">
                                <span style={{ color: '#64748b' }}>Sign in with password </span>
                                <b className="txt-blue-500 font-bold login-method-switch__link" onClick={this.switchToPassword}>
                                    Click here
                                </b>
                            </p>
                        </div>
                        </>
                        )}
                            <div className="login-footer">
                                {getRecaptchaSiteKey() ? (
                                    <p className="login-recaptcha-note" role="note">
                                        Protected by reCAPTCHA. Google{" "}
                                        <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>
                                        {" "}and{" "}
                                        <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">Terms of Service</a>
                                        {" "}apply.
                                    </p>
                                ) : null}
                                <span style={{ color: '#64748b', fontSize: '13px', fontWeight: '400' }}>
                                    © {getYear()} SuperAgentX • Version {APP_VERSION}
                                </span>
                            </div>
                    </div>
                    </div>


                    {/* Right Side - Animated Showcase */}
                    <div className={`auth-banner sx-stage ${this.state.paused ? 'is-paused' : ''}`}>
                        <div className="sx-aurora" aria-hidden="true">
                            <span className="sx-orb sx-orb--a" />
                            <span className="sx-orb sx-orb--b" />
                            <span className="sx-orb sx-orb--c" />
                            <span className="sx-grid" />
                        </div>
                        {this.renderShowcase()}
                    </div>

                </div>
                <Modal
                    className="login-privacy-modal"
                    centered
                    size="xl"
                    show={showPrivacyPolicy}
                    onHide={() => this.setState({ showPrivacyPolicy: false })}
                    aria-labelledby="login-privacy-policy-title"
                >
                    <Modal.Body className="login-privacy-modal__body">
                        <button
                            type="button"
                            className="login-privacy-modal__close"
                            aria-label="Close privacy policy"
                            onClick={() => this.setState({ showPrivacyPolicy: false })}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                        <div className="login-privacy-page">
                            <div className="login-privacy-page__header">
                                <h2 id="login-privacy-policy-title">Privacy Policy</h2>
                                <p>Last updated: March 2026</p>
                            </div>
                            <div className="login-privacy-page__card">
                                <p>This Privacy Policy explains how <b>SuperAgentX<sup>TM</sup></b> ("SuperAgentX", "we", "us") collects, uses, and protects information when you visit our website and interact with our services.</p>
                                <p>Please read this Privacy Policy carefully and in conjunction with the Terms of Use. If you do not understand this policy, or do not accept any part of it, then you should not use the Platform, as the case may be. Your use and/or continued use of the Platform, as the case may be amounts to express consent to the terms of this Privacy Policy as well as the Terms of Use.</p>
                                <p>By consenting to this Policy and accepting the Terms of Use, You agree to the collection, use, and transfer of Your personal information as outlined in this Policy. If You do not agree, please do not use the Website. We review this Policy periodically to ensure it is up-to-date. It was last updated March 2026. Visitors should note that this Policy may change at any time without notice. Registered users will be notified of changes and given the opportunity to review the revised Policy before continuing to use our services.</p>
                                <p>We do not collect any Special Categories of Personal Data. Further, if you are a Customer/User, you hereby agree and acknowledge that you shall not, under any circumstances, whether directly or indirectly, use our Services to collect or process Special Categories of Personal Data or transfer to us any such data.</p>
                                <p>The term "Special Categories of Personal Data" shall have the meaning ascribed to it under the GDPR and shall include, without limitation, data pertaining to a data subject's race, ethnic origin, genetics, political affiliations, biometrics, health or sexual orientation.</p>
                                <div className="login-privacy-modal__section">
                                    <h5>Data controller and GDPR representatives</h5>
                                    <p>According to Art. 13 GDPR, data subjects need to be provided with a set of information. It reads:</p>
                                    <blockquote>
                                        <p>"Where personal data relating to a data subject are collected from the data subject, the controller shall, at the time when personal data are obtained, provide the data subject with all of the following information:</p>
                                        <ol>
                                            <li>the identity and the contact details of the controller and, where applicable, of the controller's representative;"</li>
                                        </ol>
                                    </blockquote>
                                    <p>The data controller responsible for processing your personal data is <b>SuperAgentX<sup>TM</sup></b> ("SuperAgentX", "we", "us").</p>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th>Our EU GDPR Representative is:</th>
                                                <td>art-27-rep-deeplore-technologies</td>
                                            </tr>
                                            <tr>
                                                <th>Our UK-GDPR Representative is:</th>
                                                <td>art-27-rep-deeplore-technologies</td>
                                            </tr>
                                            <tr>
                                                <th>Contact details:</th>
                                                <td>Contact details for privacy matters, data subject requests, and communications with our GDPR representatives are provided in the Contact section of this Policy.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Information we collect</h5>
                                    <p>We collect personal data across different channels and processing activities as described below:</p>
                                    <ul>
                                        <li><b>Website interactions:</b> When you visit our website or submit a web form, we may collect identifiers and contact details such as name, email address, company name, job title, phone number, inquiry details, IP address, browser type, device information, pages viewed, referring URLs, cookies, and similar analytics data.</li>
                                        <li><b>Product usage:</b> When you access or use our Platform, we may collect account identifiers, login and authentication data, usage logs, feature interactions, configuration settings, workflow activity, performance data, error logs, audit logs, and metadata generated through your use of the services.</li>
                                        <li><b>Customer onboarding:</b> During account creation, demos, trials, contracting, or onboarding, we may collect business contact information, organization details, billing or subscription information, user roles, access permissions, implementation requirements, and communications shared during onboarding.</li>
                                        <li><b>Support services:</b> When you contact us for support, we may collect contact details, support ticket content, issue descriptions, troubleshooting information, screenshots or files you provide, diagnostic logs, correspondence, and other information needed to investigate and resolve your request.</li>
                                        <li><b>Marketing activities:</b> When you subscribe to updates, attend events, download resources, or interact with marketing campaigns, we may collect name, email address, company, job title, communication preferences, event registration details, campaign engagement data, and consent or opt-out preferences.</li>
                                    </ul>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>How we use information</h5>
                                    <ul>
                                        <li><b>To respond</b> to inquiries and provide demos or requested information.</li>
                                        <li><b>To improve</b> our website, content, and product experience.</li>
                                        <li><b>To communicate</b> product updates when you opt in.</li>
                                        <li><b>To protect</b> against fraud, abuse, and security incidents.</li>
                                    </ul>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Sharing</h5>
                                    <p>We may share information with trusted service providers who help us operate the website and business (for example, hosting, analytics, and customer communication tools). We do not sell your personal information.</p>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Cookies</h5>
                                    <p>We may use cookies and similar technologies to remember preferences and understand site usage. You can control cookies via your browser settings.</p>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Security</h5>
                                    <p>We implement reasonable technical and organizational measures to safeguard personal data against unauthorized access, disclosure, alteration, loss, or misuse.</p>
                                    <ul>
                                        <li><b>Data in transit:</b> We use secure communication protocols, including HTTPS/TLS, to encrypt personal data transmitted between your browser, our Platform, and our service providers.</li>
                                        <li><b>Data at rest:</b> Where applicable, personal data stored in our systems, databases, backups, and cloud infrastructure is protected using encryption at rest and secure key-management practices.</li>
                                        <li><b>Access controls:</b> Access to personal data is restricted to authorized personnel and service providers who require it for legitimate business purposes, subject to authentication, role-based permissions, and confidentiality obligations.</li>
                                        <li><b>Operational safeguards:</b> We use security monitoring, logging, vulnerability management, secure backups, and incident-response procedures designed to detect, prevent, and respond to security risks.</li>
                                    </ul>
                                    <p>No method of transmission or storage is 100% secure, but we periodically review and update our security practices to protect personal data in line with applicable legal and industry standards.</p>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Data retention</h5>
                                    <p>We retain information only as long as needed for the purposes described in this policy, unless a longer retention period is required or permitted by law.</p>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Your rights & preferences as a data subject</h5>
                                    <p>Subject to the GDPR and applicable law's limitations, the rights afforded to you as a data subject are:</p>
                                    <ol>
                                        <li><b>Right to be informed:</b> You have a right to be informed about the manner in which any of your personal data is collected or used which we have endeavored to do by way of this Policy.</li>
                                        <li><b>Right of access:</b> You have a right to access the personal data you have provided by requesting us to provide you with the same.</li>
                                        <li><b>Right to rectification:</b> You have a right to request us to amend or update your personal data if it is inaccurate or incomplete.</li>
                                        <li><b>Right to erasure:</b> You have a right to request us to delete your personal data.</li>
                                        <li><b>Right to restrict:</b> You have a right to request us to temporarily or permanently stop processing all or some of your personal data.</li>
                                        <li><b>Right to object:</b> You have a right, at any time, to object to our processing of your personal data under certain circumstances. You have an absolute right to object to us processing your personal data for the purposes of direct marketing.</li>
                                        <li><b>Right to data portability:</b> You have a right to request us to provide you with a copy of your personal data in electronic format and you can transmit that personal data for using another third-party's product/service.</li>
                                        <li><b>Right not to be subject to automated decision-making:</b> You have a right to not be subject to a decision based solely on automated decision making, including profiling.</li>
                                    </ol>
                                    <p>You may withdraw or revoke your consent to our processing of your personal data at any time, where processing is based on consent. Revoking consent will not affect the lawfulness of any processing carried out before your consent was withdrawn.</p>
                                    <p>If you believe we have used your personal data in violation of the rights above or have not responded to your objections, you may lodge a complaint with your local supervisory authority.</p>
                                    <p>If you wish to exercise your privacy rights, including accessing, correcting, deleting, or opting out of the processing of your personal data, you can contact us directly by <br /> emailing our Data Protection Officer at <code>dpo [at] deplore dot com</code>. We will respond to your request in accordance with applicable data protection laws.</p>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Your choices</h5>
                                    <ul>
                                        <li><b>Opt out:</b> You can unsubscribe from marketing emails at any time.</li>
                                        <li><b>Access/Deletion:</b> You may request access to or deletion of your personal information, subject to legal limits.</li>
                                    </ul>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Grievance Officer</h5>
                                    <p>The name and contact details of our Grievance Officer, who you may contact if you have any concerns, complaints or feedback pertaining to this Policy, are as follows:</p>
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Address:</th>
                                                <td>7 LAKSHMANAN NAGAR MAIN, CBI Colony, Kandanchavadi, Perungudi, Saidapet, Kanchipuram- 600096, Tamil Nadu, INDIA</td>
                                            </tr>
                                            <tr>
                                                <th>Email:</th>
                                                <td>privacy@deeplore.io</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="login-privacy-modal__section">
                                    <h5>Contact</h5>
                                    <p>For privacy questions, data subject requests, consent revocation, complaints, or communications with our GDPR representatives, contact us via the website contact form or by emailing our Data Protection Officer <br /> at  <code>dpo [at] deplore dot com</code>.</p>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}



export default withNavigate(Login);
